// Countries with their codes
export const countries = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BR', label: 'Brazil' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'CA', label: 'Canada' },
  { value: 'CN', label: 'China' },
  { value: 'CO', label: 'Colombia' },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'DK', label: 'Denmark' },
  { value: 'EG', label: 'Egypt' },
  { value: 'EE', label: 'Estonia' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GR', label: 'Greece' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JP', label: 'Japan' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MT', label: 'Malta' },
  { value: 'MX', label: 'Mexico' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'MA', label: 'Morocco' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russia' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'KR', label: 'South Korea' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syria' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VN', label: 'Vietnam' },
  { value: 'YE', label: 'Yemen' },
];

// Major cities (can be expanded based on selected country)
export const cities = {
  IN: [
    { value: 'mumbai', label: 'Mumbai' },
    { value: 'delhi', label: 'Delhi' },
    { value: 'bangalore', label: 'Bangalore' },
    { value: 'hyderabad', label: 'Hyderabad' },
    { value: 'chennai', label: 'Chennai' },
    { value: 'kolkata', label: 'Kolkata' },
    { value: 'pune', label: 'Pune' },
    { value: 'ahmedabad', label: 'Ahmedabad' },
    { value: 'jaipur', label: 'Jaipur' },
    { value: 'surat', label: 'Surat' },
    { value: 'lucknow', label: 'Lucknow' },
    { value: 'kanpur', label: 'Kanpur' },
    { value: 'nagpur', label: 'Nagpur' },
    { value: 'indore', label: 'Indore' },
    { value: 'thane', label: 'Thane' },
    { value: 'bhopal', label: 'Bhopal' },
    { value: 'visakhapatnam', label: 'Visakhapatnam' },
    { value: 'pimpri-chinchwad', label: 'Pimpri-Chinchwad' },
    { value: 'patna', label: 'Patna' },
    { value: 'vadodara', label: 'Vadodara' },
    { value: 'ghaziabad', label: 'Ghaziabad' },
    { value: 'ludhiana', label: 'Ludhiana' },
    { value: 'agra', label: 'Agra' },
    { value: 'nashik', label: 'Nashik' },
    { value: 'faridabad', label: 'Faridabad' },
    { value: 'meerut', label: 'Meerut' },
    { value: 'rajkot', label: 'Rajkot' },
    { value: 'kalyan-dombivali', label: 'Kalyan-Dombivali' },
    { value: 'vasai-virar', label: 'Vasai-Virar' },
    { value: 'varanasi', label: 'Varanasi' },
    { value: 'srinagar', label: 'Srinagar' },
    { value: 'dhanbad', label: 'Dhanbad' },
    { value: 'jodhpur', label: 'Jodhpur' },
    { value: 'kozhikode', label: 'Kozhikode' },
    { value: 'indore', label: 'Indore' },
    { value: 'guwahati', label: 'Guwahati' },
    { value: 'chandigarh', label: 'Chandigarh' },
    { value: 'hubli-dharwad', label: 'Hubli-Dharwad' },
    { value: 'raipur', label: 'Raipur' },
    { value: 'mangalore', label: 'Mangalore' },
    { value: 'dehradun', label: 'Dehradun' },
    { value: 'amritsar', label: 'Amritsar' },
    { value: 'allahabad', label: 'Allahabad' },
    { value: 'vijayawada', label: 'Vijayawada' },
    { value: 'nagpur', label: 'Nagpur' },
  ],
  US: [
    { value: 'new-york', label: 'New York' },
    { value: 'los-angeles', label: 'Los Angeles' },
    { value: 'chicago', label: 'Chicago' },
    { value: 'houston', label: 'Houston' },
    { value: 'phoenix', label: 'Phoenix' },
    { value: 'philadelphia', label: 'Philadelphia' },
    { value: 'san-antonio', label: 'San Antonio' },
    { value: 'san-diego', label: 'San Diego' },
    { value: 'dallas', label: 'Dallas' },
    { value: 'san-jose', label: 'San Jose' },
    { value: 'austin', label: 'Austin' },
    { value: 'jacksonville', label: 'Jacksonville' },
    { value: 'fort-worth', label: 'Fort Worth' },
    { value: 'columbus', label: 'Columbus' },
    { value: 'charlotte', label: 'Charlotte' },
    { value: 'san-francisco', label: 'San Francisco' },
    { value: 'indianapolis', label: 'Indianapolis' },
    { value: 'seattle', label: 'Seattle' },
    { value: 'denver', label: 'Denver' },
    { value: 'washington', label: 'Washington' },
    { value: 'boston', label: 'Boston' },
    { value: 'el-paso', label: 'El Paso' },
    { value: 'detroit', label: 'Detroit' },
    { value: 'nashville', label: 'Nashville' },
    { value: 'memphis', label: 'Memphis' },
    { value: 'portland', label: 'Portland' },
    { value: 'oklahoma-city', label: 'Oklahoma City' },
    { value: 'las-vegas', label: 'Las Vegas' },
    { value: 'milwaukee', label: 'Milwaukee' },
    { value: 'albuquerque', label: 'Albuquerque' },
    { value: 'tucson', label: 'Tucson' },
    { value: 'fresno', label: 'Fresno' },
    { value: 'sacramento', label: 'Sacramento' },
    { value: 'kansas-city', label: 'Kansas City' },
    { value: 'long-beach', label: 'Long Beach' },
    { value: 'mesa', label: 'Mesa' },
    { value: 'atlanta', label: 'Atlanta' },
    { value: 'omaha', label: 'Omaha' },
    { value: 'colorado-springs', label: 'Colorado Springs' },
    { value: 'raleigh', label: 'Raleigh' },
    { value: 'miami', label: 'Miami' },
  ],
  GB: [
    { value: 'london', label: 'London' },
    { value: 'birmingham', label: 'Birmingham' },
    { value: 'manchester', label: 'Manchester' },
    { value: 'glasgow', label: 'Glasgow' },
    { value: 'leeds', label: 'Leeds' },
    { value: 'sheffield', label: 'Sheffield' },
    { value: 'bristol', label: 'Bristol' },
    { value: 'liverpool', label: 'Liverpool' },
    { value: 'edinburgh', label: 'Edinburgh' },
    { value: 'cardiff', label: 'Cardiff' },
    { value: 'leicester', label: 'Leicester' },
    { value: 'coventry', label: 'Coventry' },
    { value: 'nottingham', label: 'Nottingham' },
    { value: 'newcastle', label: 'Newcastle' },
    { value: 'belfast', label: 'Belfast' },
    { value: 'brighton', label: 'Brighton' },
    { value: 'plymouth', label: 'Plymouth' },
    { value: 'southampton', label: 'Southampton' },
    { value: 'derby', label: 'Derby' },
    { value: 'reading', label: 'Reading' },
    { value: 'wolverhampton', label: 'Wolverhampton' },
    { value: 'bournemouth', label: 'Bournemouth' },
    { value: 'cambridge', label: 'Cambridge' },
    { value: 'oxford', label: 'Oxford' },
    { value: 'york', label: 'York' },
    { value: 'norwich', label: 'Norwich' },
    { value: 'ipswich', label: 'Ipswich' },
    { value: 'poole', label: 'Poole' },
    { value: 'swansea', label: 'Swansea' },
    { value: 'aberdeen', label: 'Aberdeen' },
    { value: 'gloucester', label: 'Gloucester' },
    { value: 'lincoln', label: 'Lincoln' },
    { value: 'chester', label: 'Chester' },
    { value: 'stoke-on-trent', label: 'Stoke-on-Trent' },
    { value: 'worcester', label: 'Worcester' },
    { value: 'hereford', label: 'Hereford' },
    { value: 'canterbury', label: 'Canterbury' },
    { value: 'exeter', label: 'Exeter' },
    { value: 'truro', label: 'Truro' },
  ],
  CA: [
    { value: 'toronto', label: 'Toronto' },
    { value: 'montreal', label: 'Montreal' },
    { value: 'vancouver', label: 'Vancouver' },
    { value: 'calgary', label: 'Calgary' },
    { value: 'edmonton', label: 'Edmonton' },
    { value: 'ottawa', label: 'Ottawa' },
    { value: 'winnipeg', label: 'Winnipeg' },
    { value: 'quebec-city', label: 'Quebec City' },
    { value: 'hamilton', label: 'Hamilton' },
    { value: 'kitchener', label: 'Kitchener' },
    { value: 'london', label: 'London' },
    { value: 'halifax', label: 'Halifax' },
    { value: 'victoria', label: 'Victoria' },
    { value: 'windsor', label: 'Windsor' },
    { value: 'oshawa', label: 'Oshawa' },
    { value: 'barrie', label: 'Barrie' },
    { value: 'sherbrooke', label: 'Sherbrooke' },
    { value: 'saskatoon', label: 'Saskatoon' },
    { value: 'regina', label: 'Regina' },
    { value: 'st-johns', label: "St. John's" },
    { value: 'kelowna', label: 'Kelowna' },
    { value: 'abbotsford', label: 'Abbotsford' },
    { value: 'kingston', label: 'Kingston' },
    { value: 'sudbury', label: 'Sudbury' },
    { value: 'saguenay', label: 'Saguenay' },
    { value: 'trois-rivieres', label: 'Trois-Rivières' },
    { value: 'guelph', label: 'Guelph' },
    { value: 'moncton', label: 'Moncton' },
    { value: 'brantford', label: 'Brantford' },
    { value: 'saint-john', label: 'Saint John' },
    { value: 'thunder-bay', label: 'Thunder Bay' },
    { value: 'london', label: 'London' },
  ],
  AU: [
    { value: 'sydney', label: 'Sydney' },
    { value: 'melbourne', label: 'Melbourne' },
    { value: 'brisbane', label: 'Brisbane' },
    { value: 'perth', label: 'Perth' },
    { value: 'adelaide', label: 'Adelaide' },
    { value: 'gold-coast', label: 'Gold Coast' },
    { value: 'canberra', label: 'Canberra' },
    { value: 'newcastle', label: 'Newcastle' },
    { value: 'wollongong', label: 'Wollongong' },
    { value: 'logan-city', label: 'Logan City' },
    { value: 'geelong', label: 'Geelong' },
    { value: 'hobart', label: 'Hobart' },
    { value: 'townsville', label: 'Townsville' },
    { value: 'cairns', label: 'Cairns' },
    { value: 'darwin', label: 'Darwin' },
    { value: 'toowoomba', label: 'Toowoomba' },
    { value: 'ballarat', label: 'Ballarat' },
    { value: 'bendigo', label: 'Bendigo' },
    { value: 'albury', label: 'Albury' },
    { value: 'launceston', label: 'Launceston' },
    { value: 'mackay', label: 'Mackay' },
    { value: 'rockhampton', label: 'Rockhampton' },
    { value: 'bunbury', label: 'Bunbury' },
    { value: 'bundaberg', label: 'Bundaberg' },
    { value: 'coffs-harbour', label: 'Coffs Harbour' },
    { value: 'wagga-wagga', label: 'Wagga Wagga' },
    { value: 'hervey-bay', label: 'Hervey Bay' },
    { value: 'mildura', label: 'Mildura' },
    { value: 'geraldton', label: 'Geraldton' },
    { value: 'sunshine-coast', label: 'Sunshine Coast' },
  ],
  PK: [
    { value: 'karachi', label: 'Karachi' },
    { value: 'lahore', label: 'Lahore' },
    { value: 'faisalabad', label: 'Faisalabad' },
    { value: 'rawalpindi', label: 'Rawalpindi' },
    { value: 'gujranwala', label: 'Gujranwala' },
    { value: 'peshawar', label: 'Peshawar' },
    { value: 'multan', label: 'Multan' },
    { value: 'islamabad', label: 'Islamabad' },
    { value: 'quetta', label: 'Quetta' },
    { value: 'sialkot', label: 'Sialkot' },
    { value: 'sargodha', label: 'Sargodha' },
    { value: 'bahawalpur', label: 'Bahawalpur' },
    { value: 'sukkur', label: 'Sukkur' },
    { value: 'jhang', label: 'Jhang' },
    { value: 'sheikhupura', label: 'Sheikhupura' },
    { value: 'mardan', label: 'Mardan' },
    { value: 'gujrat', label: 'Gujrat' },
    { value: 'larkana', label: 'Larkana' },
    { value: 'kasur', label: 'Kasur' },
    { value: 'rahim-yar-khan', label: 'Rahim Yar Khan' },
    { value: 'mianwali', label: 'Mianwali' },
    { value: 'dha-gujranwala', label: 'DHA Gujranwala' },
    { value: 'sahiwal', label: 'Sahiwal' },
    { value: 'okara', label: 'Okara' },
    { value: 'wah-cantonment', label: 'Wah Cantonment' },
    { value: 'dera-ghazi-khan', label: 'Dera Ghazi Khan' },
    { value: 'mingora', label: 'Mingora' },
    { value: 'kohat', label: 'Kohat' },
    { value: 'abbottabad', label: 'Abbottabad' },
    { value: 'bahawalnagar', label: 'Bahawalnagar' },
    { value: 'jhelum', label: 'Jhelum' },
    { value: 'sadiqabad', label: 'Sadiqabad' },
    { value: 'khanewal', label: 'Khanewal' },
    { value: 'hafizabad', label: 'Hafizabad' },
    { value: 'mardan', label: 'Mardan' },
    { value: 'mandi-bahauddin', label: 'Mandi Bahauddin' },
    { value: 'chiniot', label: 'Chiniot' },
    { value: 'kamalia', label: 'Kamalia' },
    { value: 'toba-tek-singh', label: 'Toba Tek Singh' },
  ],
  BD: [
    { value: 'dhaka', label: 'Dhaka' },
    { value: 'chattogram', label: 'Chattogram' },
    { value: 'khulna', label: 'Khulna' },
    { value: 'rajshahi', label: 'Rajshahi' },
    { value: 'sylhet', label: 'Sylhet' },
    { value: 'barisal', label: 'Barisal' },
    { value: 'rangpur', label: 'Rangpur' },
    { value: 'mymensingh', label: 'Mymensingh' },
    { value: 'comilla', label: 'Comilla' },
    { value: 'narayanganj', label: 'Narayanganj' },
    { value: 'feni', label: 'Feni' },
    { value: 'bogra', label: 'Bogra' },
    { value: 'pabna', label: 'Pabna' },
    { value: 'dinajpur', label: 'Dinajpur' },
    { value: 'jessore', label: 'Jessore' },
    { value: 'kustia', label: 'Kustia' },
    { value: 'moulvibazar', label: 'Moulvibazar' },
    { value: 'tangail', label: 'Tangail' },
    { value: 'faridpur', label: 'Faridpur' },
    { value: 'jamalpur', label: 'Jamalpur' },
    { value: 'naogaon', label: 'Naogaon' },
    { value: 'brahmanbaria', label: 'Brahmanbaria' },
    { value: 'satkhira', label: 'Satkhira' },
    { value: 'shariatpur', label: 'Shariatpur' },
    { value: 'lalmonirhat', label: 'Lalmonirhat' },
    { value: 'gopalganj', label: 'Gopalganj' },
    { value: 'gazipur', label: 'Gazipur' },
    { value: 'madaripur', label: 'Madaripur' },
    { value: 'manikganj', label: 'Manikganj' },
    { value: 'munshiganj', label: 'Munshiganj' },
    { value: 'narayanganj', label: 'Narayanganj' },
    { value: 'narsingdi', label: 'Narsingdi' },
    { value: 'chandpur', label: 'Chandpur' },
    { value: 'bhola', label: 'Bhola' },
    { value: 'lakshmipur', label: 'Lakshmipur' },
    { value: 'cox-bazar', label: "Cox's Bazar" },
    { value: 'bandarban', label: 'Bandarban' },
    { value: 'rangamati', label: 'Rangamati' },
    { value: 'khagrachari', label: 'Khagrachari' },
  ],
  AE: [
    { value: 'dubai', label: 'Dubai' },
    { value: 'abu-dhabi', label: 'Abu Dhabi' },
    { value: 'sharjah', label: 'Sharjah' },
    { value: 'al-ain', label: 'Al Ain' },
    { value: 'ajman', label: 'Ajman' },
    { value: 'ras-al-khaimah', label: 'Ras Al Khaimah' },
    { value: 'fujairah', label: 'Fujairah' },
    { value: 'umm-al-quwain', label: 'Umm Al Quwain' },
    { value: 'dibba-al-hisn', label: 'Dibba Al-Hisn' },
    { value: 'khor-fakkan', label: 'Khor Fakkan' },
    { value: 'kalba', label: 'Kalba' },
    { value: 'madha', label: 'Madha' },
    { value: 'hatta', label: 'Hatta' },
    { value: 'jebel-ali', label: 'Jebel Ali' },
    { value: 'al-quoz', label: 'Al Quoz' },
    { value: 'al-barsha', label: 'Al Barsha' },
    { value: 'al-muhaisnah', label: 'Al Muhaisnah' },
    { value: 'al-twar', label: 'Al Twar' },
    { value: 'al-wahat', label: 'Al Wahat' },
    { value: 'dubai-marina', label: 'Dubai Marina' },
    { value: 'jumeirah', label: 'Jumeirah' },
    { value: 'deira', label: 'Deira' },
    { value: 'bur-dubai', label: 'Bur Dubai' },
    { value: 'business-bay', label: 'Business Bay' },
    { value: 'downtown-dubai', label: 'Downtown Dubai' },
    { value: 'dubai-international-city', label: 'Dubai International City' },
  ],
  SA: [
    { value: 'riyadh', label: 'Riyadh' },
    { value: 'jeddah', label: 'Jeddah' },
    { value: 'mecca', label: 'Mecca' },
    { value: 'medina', label: 'Medina' },
    { value: 'dammam', label: 'Dammam' },
    { value: 'khobar', label: 'Khobar' },
    { value: 'tabuk', label: 'Tabuk' },
    { value: 'buraidah', label: 'Buraidah' },
    { value: 'hail', label: 'Hail' },
    { value: 'najran', label: 'Najran' },
    { value: 'abha', label: 'Abha' },
    { value: 'yanbu', label: 'Yanbu' },
    { value: 'arar', label: 'Arar' },
    { value: 'sakaka', label: 'Sakaka' },
    { value: 'jizan', label: 'Jizan' },
    { value: 'taif', label: 'Taif' },
    { value: 'hofuf', label: 'Hofuf' },
    { value: 'rabigh', label: 'Rabigh' },
    { value: 'unayzah', label: 'Unayzah' },
    { value: 'khamis-mushait', label: 'Khamis Mushait' },
    { value: 'al-jouf', label: 'Al Jouf' },
    { value: 'al-baha', label: 'Al Baha' },
    { value: 'al-ula', label: 'Al Ula' },
    { value: 'al-qatif', label: 'Al Qatif' },
    { value: 'al-khafji', label: 'Al Khafji' },
    { value: 'dahran', label: 'Dahran' },
    { value: 'al-hasa', label: 'Al Hasa' },
    { value: 'al-majmaah', label: 'Al Majmaah' },
    { value: 'al-rass', label: 'Al Rass' },
    { value: 'al-taraf', label: 'Al Taraf' },
    { value: 'al-wadi', label: 'Al Wadi' },
    { value: 'badr', label: 'Badr' },
    { value: 'baljurashi', label: 'Baljurashi' },
    { value: 'bisha', label: 'Bisha' },
    { value: 'dumah-al-jandal', label: "Dumah Al Jandal" },
  ],
  EG: [
    { value: 'cairo', label: 'Cairo' },
    { value: 'alexandria', label: 'Alexandria' },
    { value: 'giza', label: 'Giza' },
    { value: 'shubra-el-kheima', label: 'Shubra El Kheima' },
    { value: 'port-said', label: 'Port Said' },
    { value: 'suez', label: 'Suez' },
    { value: 'luxor', label: 'Luxor' },
    { value: 'aswan', label: 'Aswan' },
    { value: 'asyut', label: 'Asyut' },
    { value: 'ismailia', label: 'Ismailia' },
    { value: 'mansoura', label: 'Mansoura' },
    { value: 'tanta', label: 'Tanta' },
    { value: 'damanhur', label: 'Damanhur' },
    { value: 'el-mahalla-el-kubra', label: 'El Mahalla El Kubra' },
    { value: 'kom-ombo', label: 'Kom Ombo' },
    { value: 'beni-suef', label: 'Beni Suef' },
    { value: 'qena', label: 'Qena' },
    { value: 'sohag', label: 'Sohag' },
    { value: 'hurghada', label: 'Hurghada' },
    { value: 'sharm-el-sheikh', label: 'Sharm El Sheikh' },
    { value: '6th-of-october-city', label: '6th of October City' },
    { value: 'new-cairo', label: 'New Cairo' },
    { value: 'el-obour', label: 'El Obour' },
    { value: '10th-of-ramadan-city', label: '10th of Ramadan City' },
    { value: 'sadat-city', label: 'Sadat City' },
    { value: 'borg-el-arab', label: 'Borg El Arab' },
    { value: 'marsa-matrouh', label: 'Marsa Matrouh' },
    { value: 'el-alamein', label: 'El Alamein' },
    { value: 'ras-sudr', label: 'Ras Sudr' },
    { value: 'abu-zenima', label: 'Abu Zenima' },
    { value: 'safaga', label: 'Safaga' },
    { value: 'quseir', label: 'Quseir' },
    { value: 'marsa-alam', label: 'Marsa Alam' },
    { value: 'abu-tartur', label: 'Abu Tartur' },
    { value: 'kharga', label: 'Kharga' },
    { value: 'dakhla', label: 'Dakhla' },
    { value: 'farafra', label: 'Farafra' },
    { value: 'siwa', label: 'Siwa' },
  ],
  FR: [
    { value: 'paris', label: 'Paris' },
    { value: 'marseille', label: 'Marseille' },
    { value: 'lyon', label: 'Lyon' },
    { value: 'toulouse', label: 'Toulouse' },
    { value: 'nice', label: 'Nice' },
    { value: 'nantes', label: 'Nantes' },
    { value: 'strasbourg', label: 'Strasbourg' },
    { value: 'montpellier', label: 'Montpellier' },
    { value: 'bordeaux', label: 'Bordeaux' },
    { value: 'lille', label: 'Lille' },
    { value: 'rennes', label: 'Rennes' },
    { value: 'reims', label: 'Reims' },
    { value: 'le-havre', label: 'Le Havre' },
    { value: 'saint-etienne', label: 'Saint-Étienne' },
    { value: 'toulon', label: 'Toulon' },
    { value: 'grenoble', label: 'Grenoble' },
    { value: 'dijon', label: 'Dijon' },
    { value: 'angers', label: 'Angers' },
    { value: 'villeurbanne', label: 'Villeurbanne' },
    { value: 'le-mans', label: 'Le Mans' },
    { value: 'nimes', label: 'Nîmes' },
    { value: 'cannes', label: 'Cannes' },
    { value: 'aix-en-provence', label: 'Aix-en-Provence' },
    { value: 'clermont-ferrand', label: 'Clermont-Ferrand' },
    { value: 'brest', label: 'Brest' },
    { value: 'limoges', label: 'Limoges' },
    { value: 'tours', label: 'Tours' },
    { value: 'amiens', label: 'Amiens' },
    { value: 'metz', label: 'Metz' },
    { value: 'perpignan', label: 'Perpignan' },
    { value: 'rouen', label: 'Rouen' },
    { value: 'mulhouse', label: 'Mulhouse' },
    { value: 'caen', label: 'Caen' },
    { value: 'boulogne-billancourt', label: 'Boulogne-Billancourt' },
    { value: 'nancy', label: 'Nancy' },
    { value: 'argenteuil', label: 'Argenteuil' },
    { value: 'saint-denis', label: 'Saint-Denis' },
    { value: 'roubaix', label: 'Roubaix' },
    { value: 'tourcoing', label: 'Tourcoing' },
    { value: 'montreuil', label: 'Montreuil' },
    { value: 'avignon', label: 'Avignon' },
    { value: 'versailles', label: 'Versailles' },
    { value: 'creteil', label: 'Créteil' },
    { value: 'dunkerque', label: 'Dunkerque' },
    { value: 'poitiers', label: 'Poitiers' },
    { value: 'courbevoie', label: 'Courbevoie' },
    { value: 'nanterre', label: 'Nanterre' },
    { value: 'asnières-sur-seine', label: 'Asnières-sur-Seine' },
    { value: 'colmar', label: 'Colmar' },
    { value: 'chelles', label: 'Chelles' },
    { value: 'ajaccio', label: 'Ajaccio' },
  ],
  DE: [
    { value: 'berlin', label: 'Berlin' },
    { value: 'hamburg', label: 'Hamburg' },
    { value: 'munich', label: 'Munich' },
    { value: 'cologne', label: 'Cologne' },
    { value: 'frankfurt', label: 'Frankfurt' },
    { value: 'stuttgart', label: 'Stuttgart' },
    { value: 'dusseldorf', label: 'Düsseldorf' },
    { value: 'dortmund', label: 'Dortmund' },
    { value: 'essen', label: 'Essen' },
    { value: 'leipzig', label: 'Leipzig' },
    { value: 'bremen', label: 'Bremen' },
    { value: 'dresden', label: 'Dresden' },
    { value: 'hannover', label: 'Hannover' },
    { value: 'nuremberg', label: 'Nuremberg' },
    { value: 'duisburg', label: 'Duisburg' },
    { value: 'bochum', label: 'Bochum' },
    { value: 'wuppertal', label: 'Wuppertal' },
    { value: 'bielefeld', label: 'Bielefeld' },
    { value: 'bonn', label: 'Bonn' },
    { value: 'mannheim', label: 'Mannheim' },
    { value: 'karlsruhe', label: 'Karlsruhe' },
    { value: 'augsburg', label: 'Augsburg' },
    { value: 'wiesbaden', label: 'Wiesbaden' },
    { value: 'mönchengladbach', label: 'Mönchengladbach' },
    { value: 'gelsenkirchen', label: 'Gelsenkirchen' },
    { value: 'aachen', label: 'Aachen' },
    { value: 'krefeld', label: 'Krefeld' },
    { value: 'magdeburg', label: 'Magdeburg' },
    { value: 'kassel', label: 'Kassel' },
    { value: 'saarbrücken', label: 'Saarbrücken' },
    { value: 'heidelberg', label: 'Heidelberg' },
    { value: 'heilbronn', label: 'Heilbronn' },
    { value: 'freiburg', label: 'Freiburg' },
    { value: 'kaiserslautern', label: 'Kaiserslautern' },
    { value: 'ingolstadt', label: 'Ingolstadt' },
    { value: 'ulm', label: 'Ulm' },
    { value: 'hagen', label: 'Hagen' },
    { value: 'potsdam', label: 'Potsdam' },
    { value: 'reutlingen', label: 'Reutlingen' },
    { value: 'oldenburg', label: 'Oldenburg' },
    { value: 'ludwigshafen', label: 'Ludwigshafen' },
    { value: 'leverkusen', label: 'Leverkusen' },
    { value: 'osnabrück', label: 'Osnabrück' },
    { value: 'solingen', label: 'Solingen' },
    { value: 'herne', label: 'Herne' },
    { value: 'neuss', label: 'Neuss' },
    { value: 'paderborn', label: 'Paderborn' },
    { value: 'ingolstadt', label: 'Ingolstadt' },
    { value: 'mulheim-an-der-ruhr', label: 'Mülheim an der Ruhr' },
    { value: 'cuxhaven', label: 'Cuxhaven' },
    { value: 'cotbus', label: 'Cottbus' },
    { value: 'gorlitz', label: 'Görlitz' },
    { value: 'konstanz', label: 'Konstanz' },
    { value: 'reutlingen', label: 'Reutlingen' },
    { value: 'weimar', label: 'Weimar' },
    { value: 'zwickau', label: 'Zwickau' },
    { value: 'koblenz', label: 'Koblenz' },
    { value: 'erfurt', label: 'Erfurt' },
  ],
  IT: [
    { value: 'rome', label: 'Rome' },
    { value: 'milan', label: 'Milan' },
    { value: 'naples', label: 'Naples' },
    { value: 'turin', label: 'Turin' },
    { value: 'palermo', label: 'Palermo' },
    { value: 'genoa', label: 'Genoa' },
    { value: 'bologna', label: 'Bologna' },
    { value: 'florence', label: 'Florence' },
    { value: 'bari', label: 'Bari' },
    { value: 'catania', label: 'Catania' },
    { value: 'venice', label: 'Venice' },
    { value: 'verona', label: 'Verona' },
    { value: 'messina', label: 'Messina' },
    { value: 'padua', label: 'Padua' },
    { value: 'trieste', label: 'Trieste' },
    { value: 'brescia', label: 'Brescia' },
    { value: 'taranto', label: 'Taranto' },
    { value: 'prato', label: 'Prato' },
    { value: 'reggio-calabria', label: 'Reggio Calabria' },
    { value: 'modena', label: 'Modena' },
    { value: 'perugia', label: 'Perugia' },
    { value: 'livorno', label: 'Livorno' },
    { value: 'ravenna', label: 'Ravenna' },
    { value: 'cagliari', label: 'Cagliari' },
    { value: 'foggia', label: 'Foggia' },
    { value: 'rimini', label: 'Rimini' },
    { value: 'salerno', label: 'Salerno' },
    { value: 'ferrara', label: 'Ferrara' },
    { value: 'sassari', label: 'Sassari' },
    { value: 'syracuse', label: 'Syracuse' },
    { value: 'pescara', label: 'Pescara' },
    { value: 'bergamo', label: 'Bergamo' },
    { value: 'forlì', label: 'Forlì' },
    { value: 'trento', label: 'Trento' },
    { value: 'vicenza', label: 'Vicenza' },
    { value: 'trento', label: 'Trento' },
    { value: 'monza', label: 'Monza' },
    { value: 'brescia', label: 'Brescia' },
    { value: 'latina', label: 'Latina' },
    { value: 'brindisi', label: 'Brindisi' },
    { value: 'como', label: 'Como' },
    { value: 'venice', label: 'Venice' },
    { value: 'ancona', label: 'Ancona' },
    { value: 'andria', label: 'Andria' },
    { value: 'arezzo', label: 'Arezzo' },
    { value: 'cesena', label: 'Cesena' },
    { value: 'lecce', label: 'Lecce' },
    { value: 'livorno', label: 'Livorno' },
    { value: 'biella', label: 'Biella' },
    { value: 'gallarate', label: 'Gallarate' },
    { value: 'modena', label: 'Modena' },
    { value: 'piacenza', label: 'Piacenza' },
    { value: 'siracusa', label: 'Siracusa' },
    { value: 'terni', label: 'Terni' },
    { value: 'novara', label: 'Novara' },
    { value: 'asti', label: 'Asti' },
    { value: 'bolzano', label: 'Bolzano' },
    { value: 'alessandria', label: 'Alessandria' },
    { value: 'la-spezia', label: 'La Spezia' },
    { value: 'cuneo', label: 'Cuneo' },
    { value: 'cremona', label: 'Cremona' },
    { value: 'pistoia', label: 'Pistoia' },
    { value: 'ferrara', label: 'Ferrara' },
    { value: 'vicenza', label: 'Vicenza' },
    { value: 'imperia', label: 'Imperia' },
    { value: 'savona', label: 'Savona' },
    { value: 'vercelli', label: 'Vercelli' },
    { value: 'bergamo', label: 'Bergamo' },
  ],
  ES: [
    { value: 'madrid', label: 'Madrid' },
    { value: 'barcelona', label: 'Barcelona' },
    { value: 'valencia', label: 'Valencia' },
    { value: 'seville', label: 'Seville' },
    { value: 'malaga', label: 'Malaga' },
    { value: 'bilbao', label: 'Bilbao' },
    { value: 'alicante', label: 'Alicante' },
    { value: 'murcia', label: 'Murcia' },
    { value: 'palma', label: 'Palma' },
    { value: 'las-palmas', label: 'Las Palmas' },
    { value: 'zaragoza', label: 'Zaragoza' },
    { value: 'vigo', label: 'Vigo' },
    { value: 'gijon', label: 'Gijón' },
    { value: 'hospitalet-de-llobregat', label: "L'Hospitalet de Llobregat" },
    { value: 'vitoria-gasteiz', label: 'Vitoria-Gasteiz' },
    { value: 'a-coruna', label: 'A Coruña' },
    { value: 'granada', label: 'Granada' },
    { value: 'elche', label: 'Elche' },
    { value: 'cartagena', label: 'Cartagena' },
    { value: 'santa-cruz-de-tenerife', label: 'Santa Cruz de Tenerife' },
    { value: 'malaga', label: 'Malaga' },
    { value: 'pamplona', label: 'Pamplona' },
    { value: 'almeria', label: 'Almería' },
    { value: 'leganes', label: 'Leganés' },
    { value: 'santander', label: 'Santander' },
    { value: 'castellon-de-la-plana', label: 'Castellón de la Plana' },
    { value: 'badalona', label: 'Badalona' },
    { value: 'jerez-de-la-frontera', label: 'Jerez de la Frontera' },
    { value: 'san-sebastian', label: 'San Sebastián' },
    { value: 'donostia', label: 'Donostia' },
    { value: 'sabadell', label: 'Sabadell' },
    { value: 'mostoles', label: 'Móstoles' },
    { value: 'la-coruna', label: 'La Coruña' },
    { value: 'alcala-de-henares', label: 'Alcalá de Henares' },
    { value: 'fuenlabrada', label: 'Fuenlabrada' },
    { value: 'getafe', label: 'Getafe' },
    { value: 'albacete', label: 'Albacete' },
    { value: 'gandia', label: 'Gandia' },
    { value: 'el-prat-de-llobregat', label: 'El Prat de Llobregat' },
    { value: 'terrassa', label: 'Terrassa' },
    { value: 'badajoz', label: 'Badajoz' },
    { value: 'salamanca', label: 'Salamanca' },
    { value: 'logrono', label: 'Logroño' },
    { value: 'san-cristobal-de-la-laguna', label: 'San Cristóbal de la Laguna' },
    { value: 'leon', label: 'León' },
    { value: 'daimiel', label: 'Daimiel' },
    { value: 'lugo', label: 'Lugo' },
    { value: 'santiago-de-compostela', label: 'Santiago de Compostela' },
    { value: 'lerida', label: 'Lérida' },
    { value: 'huelva', label: 'Huelva' },
    { value: 'cadiz', label: 'Cádiz' },
    { value: 'ceuta', label: 'Ceuta' },
    { value: 'melilla', label: 'Melilla' },
    { value: 'almeria', label: 'Almería' },
    { value: 'burgos', label: 'Burgos' },
    { value: 'soria', label: 'Soria' },
    { value: 'teruel', label: 'Teruel' },
    { value: 'huesca', label: 'Huesca' },
    { value: 'zamora', label: 'Zamora' },
    { value: 'segovia', label: 'Segovia' },
    { value: 'avila', label: 'Ávila' },
    { value: 'cuenca', label: 'Cuenca' },
    { value: 'guadalajara', label: 'Guadalajara' },
    { value: 'toledo', label: 'Toledo' },
    { value: 'ciudad-real', label: 'Ciudad Real' },
    { value: 'puertollano', label: 'Puertollano' },
    { value: 'albacete', label: 'Albacete' },
    { value: 'valdepenas', label: 'Valdepeñas' },
    { value: 'manzanares', label: 'Manzanares' },
    { value: 'alcazar-de-san-juan', label: 'Alcázar de San Juan' },
    { value: 'tomelloso', label: 'Tomelloso' },
  ],
  NL: [
    { value: 'amsterdam', label: 'Amsterdam' },
    { value: 'rotterdam', label: 'Rotterdam' },
    { value: 'the-hague', label: 'The Hague' },
    { value: 'utrecht', label: 'Utrecht' },
    { value: 'eindhoven', label: 'Eindhoven' },
    { value: 'groningen', label: 'Groningen' },
    { value: 'tilburg', label: 'Tilburg' },
    { value: 'almere', label: 'Almere' },
    { value: 'breda', label: 'Breda' },
    { value: 'nijmegen', label: 'Nijmegen' },
    { value: 'apeldoorn', label: 'Apeldoorn' },
    { value: 'haarlem', label: 'Haarlem' },
    { value: 'enschede', label: 'Enschede' },
    { value: 'arnhem', label: 'Arnhem' },
    { value: 'zaanstad', label: 'Zaanstad' },
    { value: 'amersfoort', label: 'Amersfoort' },
    { value: 'maastricht', label: 'Maastricht' },
    { value: 'dordrecht', label: 'Dordrecht' },
    { value: 'leiden', label: 'Leiden' },
    { value: 'haarlemmermeer', label: 'Haarlemmermeer' },
    { value: 'zoetermeer', label: 'Zoetermeer' },
    { value: 'emmeloord', label: 'Emmeloord' },
    { value: 'zwolle', label: 'Zwolle' },
    { value: 'venlo', label: 'Venlo' },
    { value: 'utrecht', label: 'Utrecht' },
    { value: 'eindhoven', label: 'Eindhoven' },
    { value: 'tilburg', label: 'Tilburg' },
    { value: 'groningen', label: 'Groningen' },
    { value: 'almere', label: 'Almere' },
    { value: 'breda', label: 'Breda' },
    { value: 'nijmegen', label: 'Nijmegen' },
    { value: 'apeldoorn', label: 'Apeldoorn' },
    { value: 'haarlem', label: 'Haarlem' },
    { value: 'enschede', label: 'Enschede' },
    { value: 'arnhem', label: 'Arnhem' },
    { value: 'zaanstad', label: 'Zaanstad' },
    { value: 'amersfoort', label: 'Amersfoort' },
    { value: 'maastricht', label: 'Maastricht' },
    { value: 'dordrecht', label: 'Dordrecht' },
    { value: 'leiden', label: 'Leiden' },
    { value: 'haarlemmermeer', label: 'Haarlemmermeer' },
    { value: 'zoetermeer', label: 'Zoetermeer' },
    { value: 'emmeloord', label: 'Emmeloord' },
    { value: 'zwolle', label: 'Zwolle' },
    { value: 'venlo', label: 'Venlo' },
    { value: 'utrecht', label: 'Utrecht' },
    { value: 'eindhoven', label: 'Eindhoven' },
    { value: 'tilburg', label: 'Tilburg' },
    { value: 'groningen', label: 'Groningen' },
    { value: 'almere', label: 'Almere' },
    { value: 'breda', label: 'Breda' },
    { value: 'nijmegen', label: 'Nijmegen' },
    { value: 'apeldoorn', label: 'Apeldoorn' },
    { value: 'haarlem', label: 'Haarlem' },
    { value: 'enschede', label: 'Enschede' },
    { value: 'arnhem', label: 'Arnhem' },
    { value: 'zaanstad', label: 'Zaanstad' },
    { value: 'amersfoort', label: 'Amersfoort' },
    { value: 'maastricht', label: 'Maastricht' },
    { value: 'dordrecht', label: 'Dordrecht' },
    { value: 'leiden', label: 'Leiden' },
    { value: 'haarlemmermeer', label: 'Haarlemmermeer' },
    { value: 'zoetermeer', label: 'Zoetermeer' },
    { value: 'emmeloord', label: 'Emmeloord' },
    { value: 'zwolle', label: 'Zwolle' },
    { value: 'venlo', label: 'Venlo' },
  ],
  // Add more countries as needed
  CN: [
    { value: 'beijing', label: 'Beijing' },
    { value: 'shanghai', label: 'Shanghai' },
    { value: 'guangzhou', label: 'Guangzhou' },
    { value: 'shenzhen', label: 'Shenzhen' },
    { value: 'chongqing', label: 'Chongqing' },
    { value: 'tianjin', label: 'Tianjin' },
    { value: 'wuhan', label: 'Wuhan' },
    { value: 'dongguan', label: 'Dongguan' },
    { value: 'shenyang', label: 'Shenyang' },
    { value: 'hangzhou', label: 'Hangzhou' },
    { value: 'harbin', label: 'Harbin' },
    { value: 'suzhou', label: 'Suzhou' },
    { value: 'nanjing', label: 'Nanjing' },
    { value: 'chengdu', label: 'Chengdu' },
    { value: 'xian', label: "Xi'an" },
    { value: 'zhengzhou', label: 'Zhengzhou' },
    { value: 'qingdao', label: 'Qingdao' },
    { value: 'dalian', label: 'Dalian' },
    { value: 'changsha', label: 'Changsha' },
    { value: 'ningbo', label: 'Ningbo' },
    { value: 'kunming', label: 'Kunming' },
    { value: 'hefei', label: 'Hefei' },
    { value: 'fuzhou', label: 'Fuzhou' },
    { value: 'jinan', label: 'Jinan' },
    { value: 'nanchang', label: 'Nanchang' },
    { value: 'guilin', label: 'Guilin' },
    { value: 'taiyuan', label: 'Taiyuan' },
    { value: 'shijiazhuang', label: 'Shijiazhuang' },
    { value: 'lanzhou', label: 'Lanzhou' },
    { value: 'urumqi', label: 'Urumqi' },
    { value: 'guiyang', label: 'Guiyang' },
    { value: 'nanning', label: 'Nanning' },
    { value: 'haikou', label: 'Haikou' },
    { value: 'xining', label: 'Xining' },
    { value: 'lhasa', label: 'Lhasa' },
    { value: 'hohhot', label: 'Hohhot' },
    { value: 'yinchuan', label: 'Yinchuan' },
    { value: 'changchun', label: 'Changchun' },
    { value: 'xiamen', label: 'Xiamen' },
    { value: 'wuxi', label: 'Wuxi' },
    { value: 'sanya', label: 'Sanya' },
    { value: 'weihai', label: 'Weihai' },
    { value: 'yantai', label: 'Yantai' },
    { value: 'quanzhou', label: 'Quanzhou' },
    { value: 'shantou', label: 'Shantou' },
    { value: 'jiaxing', label: 'Jiaxing' },
    { value: 'zhongshan', label: 'Zhongshan' },
    { value: 'zhuhai', label: 'Zhuhai' },
    { value: 'dongying', label: 'Dongying' },
    { value: 'zaozhuang', label: 'Zaozhuang' },
    { value: 'jining', label: 'Jining' },
    { value: 'taian', label: "Tai'an" },
    { value: 'weifang', label: 'Weifang' },
    { value: 'linyi', label: 'Linyi' },
    { value: 'heze', label: 'Heze' },
    { value: 'binzhou', label: 'Binzhou' },
    { value: 'dezhou', label: 'Dezhou' },
    { value: 'liaocheng', label: 'Liaocheng' },
    { value: 'zaozhuang', label: 'Zaozhuang' },
    { value: 'jining', label: 'Jining' },
    { value: 'taian', label: "Tai'an" },
    { value: 'weifang', label: 'Weifang' },
    { value: 'linyi', label: 'Linyi' },
    { value: 'heze', label: 'Heze' },
    { value: 'binzhou', label: 'Binzhou' },
    { value: 'dezhou', label: 'Dezhou' },
    { value: 'liaocheng', label: 'Liaocheng' },
  ],
  JP: [
    { value: 'tokyo', label: 'Tokyo' },
    { value: 'osaka', label: 'Osaka' },
    { value: 'kyoto', label: 'Kyoto' },
    { value: 'yokohama', label: 'Yokohama' },
    { value: 'nagoya', label: 'Nagoya' },
    { value: 'sapporo', label: 'Sapporo' },
    { value: 'kobe', label: 'Kobe' },
    { value: 'fukuoka', label: 'Fukuoka' },
    { value: 'sendai', label: 'Sendai' },
    { value: 'hiroshima', label: 'Hiroshima' },
    { value: 'chiba', label: 'Chiba' },
    { value: 'kitakyushu', label: 'Kitakyushu' },
    { value: 'kawasaki', label: 'Kawasaki' },
    { value: 'saitama', label: 'Saitama' },
    { value: 'nagasaki', label: 'Nagasaki' },
    { value: 'kumamoto', label: 'Kumamoto' },
    { value: 'okayama', label: 'Okayama' },
    { value: 'saga', label: 'Saga' },
    { value: 'nagano', label: 'Nagano' },
    { value: 'niigata', label: 'Niigata' },
    { value: 'toyama', label: 'Toyama' },
    { value: 'ishikawa', label: 'Ishikawa' },
    { value: 'fukui', label: 'Fukui' },
    { value: 'yamanashi', label: 'Yamanashi' },
    { value: 'nagano', label: 'Nagano' },
    { value: 'gifu', label: 'Gifu' },
    { value: 'shizuoka', label: 'Shizuoka' },
    { value: 'aichi', label: 'Aichi' },
    { value: 'mie', label: 'Mie' },
    { value: 'shiga', label: 'Shiga' },
    { value: 'kyoto', label: 'Kyoto' },
    { value: 'osaka', label: 'Osaka' },
    { value: 'hyogo', label: 'Hyogo' },
    { value: 'nara', label: 'Nara' },
    { value: 'wakayama', label: 'Wakayama' },
    { value: 'tottori', label: 'Tottori' },
    { value: 'shimane', label: 'Shimane' },
    { value: 'okayama', label: 'Okayama' },
    { value: 'hiroshima', label: 'Hiroshima' },
    { value: 'yamaguchi', label: 'Yamaguchi' },
    { value: 'tokushima', label: 'Tokushima' },
    { value: 'kagawa', label: 'Kagawa' },
    { value: 'ehime', label: 'Ehime' },
    { value: 'kochi', label: 'Kochi' },
    { value: 'fukuoka', label: 'Fukuoka' },
    { value: 'saga', label: 'Saga' },
    { value: 'nagasaki', label: 'Nagasaki' },
    { value: 'kumamoto', label: 'Kumamoto' },
    { value: 'oita', label: 'Oita' },
    { value: 'miyazaki', label: 'Miyazaki' },
    { value: 'kagoshima', label: 'Kagoshima' },
    { value: 'okinawa', label: 'Okinawa' },
  ],
  // Add more countries as needed
};

// Default cities for countries not in the above list
export const defaultCities = [
  { value: 'capital-city', label: 'Capital City' },
  { value: 'major-city-1', label: 'Major City 1' },
  { value: 'major-city-2', label: 'Major City 2' },
  { value: 'major-city-3', label: 'Major City 3' },
];

// Height options (in cm)
export const heightsCm = Array.from({ length: 121 }, (_, i) => {
  const cm = 120 + i; // From 120cm to 240cm
  const feet = Math.floor(cm / 30.48);
  const inches = Math.round((cm % 30.48) / 2.54);
  return {
    value: cm,
    label: `${cm} cm (${feet}'${inches}")`
  };
});

// Height options (in feet and inches) - keeping for backward compatibility
export const heights = [
  { value: "4'0\"", label: "4'0\" (122 cm)" },
  { value: "4'1\"", label: "4'1\" (124 cm)" },
  { value: "4'2\"", label: "4'2\" (127 cm)" },
  { value: "4'3\"", label: "4'3\" (129 cm)" },
  { value: "4'4\"", label: "4'4\" (132 cm)" },
  { value: "4'5\"", label: "4'5\" (134 cm)" },
  { value: "4'6\"", label: "4'6\" (137 cm)" },
  { value: "4'7\"", label: "4'7\" (139 cm)" },
  { value: "4'8\"", label: "4'8\" (142 cm)" },
  { value: "4'9\"", label: "4'9\" (144 cm)" },
  { value: "4'10\"", label: "4'10\" (147 cm)" },
  { value: "4'11\"", label: "4'11\" (149 cm)" },
  { value: "5'0\"", label: "5'0\" (152 cm)" },
  { value: "5'1\"", label: "5'1\" (154 cm)" },
  { value: "5'2\"", label: "5'2\" (157 cm)" },
  { value: "5'3\"", label: "5'3\" (160 cm)" },
  { value: "5'4\"", label: "5'4\" (162 cm)" },
  { value: "5'5\"", label: "5'5\" (165 cm)" },
  { value: "5'6\"", label: "5'6\" (167 cm)" },
  { value: "5'7\"", label: "5'7\" (170 cm)" },
  { value: "5'8\"", label: "5'8\" (173 cm)" },
  { value: "5'9\"", label: "5'9\" (175 cm)" },
  { value: "5'10\"", label: "5'10\" (178 cm)" },
  { value: "5'11\"", label: "5'11\" (180 cm)" },
  { value: "6'0\"", label: "6'0\" (183 cm)" },
  { value: "6'1\"", label: "6'1\" (185 cm)" },
  { value: "6'2\"", label: "6'2\" (188 cm)" },
  { value: "6'3\"", label: "6'3\" (190 cm)" },
  { value: "6'4\"", label: "6'4\" (193 cm)" },
  { value: "6'5\"", label: "6'5\" (195 cm)" },
  { value: "6'6\"", label: "6'6\" (198 cm)" },
  { value: "6'7\"", label: "6'7\" (200 cm)" },
  { value: "6'8\"", label: "6'8\" (203 cm)" },
  { value: "6'9\"", label: "6'9\" (205 cm)" },
  { value: "6'10\"", label: "6'10\" (208 cm)" },
  { value: "6'11\"", label: "6'11\" (210 cm)" },
  { value: "7'0\"", label: "7'0\" (213 cm)" },
];

// Age options
export const ages = Array.from({ length: 73 }, (_, i) => {
  const age = 18 + i;
  return {
    value: age,
    label: `${age} years`
  };
});

// Religion options
export const religions = [
  { value: 'muslim', label: 'Muslim' },
  { value: 'christian', label: 'Christian' },
  { value: 'other', label: 'Other' },
  { value: 'hindu', label: 'Hindu' },
  { value: 'sikh', label: 'Sikh' },
  { value: 'jain', label: 'Jain' },
  { value: 'buddhist', label: 'Buddhist' },
  { value: 'parsis', label: 'Parsi' },
  { value: 'jewish', label: 'Jewish' },
  { value: 'bahai', label: 'Bahai' },
  { value: 'none', label: 'None' },
  { value: 'prefer-not-to-say', label: 'Prefer not to say' },
];

// Education options
export const educations = [
  { value: 'high-school', label: 'High School' },
  { value: 'some-college', label: 'Some College' },
  { value: 'associate', label: 'Associate Degree' },
  { value: 'bachelor', label: 'Bachelor\'s Degree' },
  { value: 'master', label: 'Master\'s Degree' },
  { value: 'phd', label: 'PhD' },
  { value: 'md', label: 'MD (Doctor of Medicine)' },
  { value: 'jd', label: 'JD (Law Degree)' },
  { value: 'other-professional', label: 'Other Professional Degree' },
  { value: 'trade-school', label: 'Trade School' },
  { value: 'other', label: 'Other' },
];



// Marital status options
export const maritalStatuses = [
  { value: 'never-married', label: 'Never Married' },
  { value: 'divorced', label: 'Divorced' },
  { value: 'widowed', label: 'Widowed' },
  { value: 'separated', label: 'Separated' },
  { value: 'annulled', label: 'Annulled' },
];

// Diet options
export const diets = [
  { value: 'vegetarian', label: 'Vegetarian' },
  { value: 'vegan', label: 'Vegan' },
  { value: 'non-vegetarian', label: 'Non-Vegetarian' },
  { value: 'eggetarian', label: 'Eggetarian' },
  { value: 'jain', label: 'Jain' },
  { value: 'other', label: 'Other' },
];

// Exercise frequency
export const exerciseFrequencies = [
  { value: 'never', label: 'Never' },
  { value: 'rarely', label: 'Rarely (1-2 times/month)' },
  { value: 'sometimes', label: 'Sometimes (1-2 times/week)' },
  { value: 'regularly', label: 'Regularly (3-4 times/week)' },
  { value: 'very-regularly', label: 'Very Regularly (5+ times/week)' },
];

// Smoking habits
export const smokingHabits = [
  { value: 'never', label: 'Never' },
  { value: 'occasionally', label: 'Occasionally' },
  { value: 'regularly', label: 'Regularly' },
  { value: 'trying-to-quit', label: 'Trying to quit' },
];

// Drinking habits
export const drinkingHabits = [
  { value: 'never', label: 'Never' },
  { value: 'occasionally', label: 'Occasionally' },
  { value: 'socially', label: 'Socially' },
  { value: 'regularly', label: 'Regularly' },
];

// Body type options
export const bodyTypes = [
  { value: 'slim', label: 'Slim' },
  { value: 'athletic', label: 'Athletic' },
  { value: 'average', label: 'Average' },
  { value: 'heavy', label: 'Heavy' },
  { value: 'other', label: 'Other' },
];

// Skin tone options
export const skinTones = [
  { value: 'very-fair', label: 'Very Fair' },
  { value: 'fair', label: 'Fair' },
  { value: 'wheatish', label: 'Wheatish' },
  { value: 'tan', label: 'Tan' },
  { value: 'dark', label: 'Dark' },
];

// Timezone options
export const timezones = [
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)' },
  { value: 'GMT', label: 'GMT (Greenwich Mean Time)' },
  { value: 'EST', label: 'EST (Eastern Standard Time) - UTC-5' },
  { value: 'EDT', label: 'EDT (Eastern Daylight Time) - UTC-4' },
  { value: 'CST', label: 'CST (Central Standard Time) - UTC-6' },
  { value: 'CDT', label: 'CDT (Central Daylight Time) - UTC-5' },
  { value: 'MST', label: 'MST (Mountain Standard Time) - UTC-7' },
  { value: 'MDT', label: 'MDT (Mountain Daylight Time) - UTC-6' },
  { value: 'PST', label: 'PST (Pacific Standard Time) - UTC-8' },
  { value: 'PDT', label: 'PDT (Pacific Daylight Time) - UTC-7' },
  { value: 'AKST', label: 'AKST (Alaska Standard Time) - UTC-9' },
  { value: 'AKDT', label: 'AKDT (Alaska Daylight Time) - UTC-8' },
  { value: 'HST', label: 'HST (Hawaii Standard Time) - UTC-10' },
  { value: 'AST', label: 'AST (Atlantic Standard Time) - UTC-4' },
  { value: 'ADT', label: 'ADT (Atlantic Daylight Time) - UTC-3' },
  { value: 'NST', label: 'NST (Newfoundland Standard Time) - UTC-3:30' },
  { value: 'NDT', label: 'NDT (Newfoundland Daylight Time) - UTC-2:30' },

  // European timezones
  { value: 'CET', label: 'CET (Central European Time) - UTC+1' },
  { value: 'CEST', label: 'CEST (Central European Summer Time) - UTC+2' },
  { value: 'WET', label: 'WET (Western European Time) - UTC+0' },
  { value: 'WEST', label: 'WEST (Western European Summer Time) - UTC+1' },
  { value: 'EET', label: 'EET (Eastern European Time) - UTC+2' },
  { value: 'EEST', label: 'EEST (Eastern European Summer Time) - UTC+3' },
  { value: 'MSK', label: 'MSK (Moscow Standard Time) - UTC+3' },
  { value: 'MSD', label: 'MSD (Moscow Daylight Time) - UTC+4' },
  { value: 'BST', label: 'BST (British Summer Time) - UTC+1' },
  { value: 'IST', label: 'IST (Irish Standard Time) - UTC+1' },

  // Asian timezones
  { value: 'IST', label: 'IST (India Standard Time) - UTC+5:30' },
  { value: 'PKT', label: 'PKT (Pakistan Standard Time) - UTC+5' },
  { value: 'BDT', label: 'BDT (Bangladesh Standard Time) - UTC+6' },
  { value: 'LKT', label: 'LKT (Sri Lanka Time) - UTC+5:30' },
  { value: 'NPT', label: 'NPT (Nepal Time) - UTC+5:45' },
  { value: 'CST', label: 'CST (China Standard Time) - UTC+8' },
  { value: 'HKT', label: 'HKT (Hong Kong Time) - UTC+8' },
  { value: 'SGT', label: 'SGT (Singapore Time) - UTC+8' },
  { value: 'WIB', label: 'WIB (Western Indonesia Time) - UTC+7' },
  { value: 'WITA', label: 'WITA (Central Indonesia Time) - UTC+8' },
  { value: 'WIT', label: 'WIT (Eastern Indonesia Time) - UTC+9' },
  { value: 'PHT', label: 'PHT (Philippines Time) - UTC+8' },
  { value: 'JST', label: 'JST (Japan Standard Time) - UTC+9' },
  { value: 'KST', label: 'KST (Korea Standard Time) - UTC+9' },
  { value: 'ICT', label: 'ICT (Indochina Time) - UTC+7' },
  { value: 'MYT', label: 'MYT (Malaysia Time) - UTC+8' },
  { value: 'BRT', label: 'BRT (Brunei Time) - UTC+8' },

  // Middle Eastern timezones
  { value: 'TRT', label: 'TRT (Turkey Time) - UTC+3' },
  { value: 'EET', label: 'EET (Eastern European Time) - UTC+2' },
  { value: 'IDT', label: 'IDT (Israel Daylight Time) - UTC+3' },
  { value: 'AST', label: 'AST (Arabia Standard Time) - UTC+3' },
  { value: 'IRST', label: 'IRST (Iran Standard Time) - UTC+3:30' },
  { value: 'IRDT', label: 'IRDT (Iran Daylight Time) - UTC+4:30' },
  { value: 'GST', label: 'GST (Gulf Standard Time) - UTC+4' },
  { value: 'AST', label: 'AST (Arab Standard Time) - UTC+3' },

  // African timezones
  { value: 'WAT', label: 'WAT (West Africa Time) - UTC+1' },
  { value: 'WAST', label: 'WAST (West Africa Summer Time) - UTC+2' },
  { value: 'CAT', label: 'CAT (Central Africa Time) - UTC+2' },
  { value: 'CAST', label: 'CAST (Central Africa Summer Time) - UTC+3' },
  { value: 'EAT', label: 'EAT (East Africa Time) - UTC+3' },
  { value: 'EAST', label: 'EAST (East Africa Summer Time) - UTC+4' },
  { value: 'SAST', label: 'SAST (South Africa Standard Time) - UTC+2' },
  { value: 'SAST', label: 'SAST (South African Standard Time) - UTC+2' },

  // Australian and New Zealand timezones
  { value: 'AWST', label: 'AWST (Australian Western Standard Time) - UTC+8' },
  { value: 'ACST', label: 'ACST (Australian Central Standard Time) - UTC+9:30' },
  { value: 'ACDT', label: 'ACDT (Australian Central Daylight Time) - UTC+10:30' },
  { value: 'AEST', label: 'AEST (Australian Eastern Standard Time) - UTC+10' },
  { value: 'AEDT', label: 'AEDT (Australian Eastern Daylight Time) - UTC+11' },
  { value: 'NZST', label: 'NZST (New Zealand Standard Time) - UTC+12' },
  { value: 'NZDT', label: 'NZDT (New Zealand Daylight Time) - UTC+13' },
  { value: 'LINT', label: 'LINT (Line Islands Time) - UTC+14' },
  { value: 'CHAST', label: 'CHAST (Chatham Standard Time) - UTC+12:45' },
  { value: 'CHADT', label: 'CHADT (Chatham Daylight Time) - UTC+13:45' },

  // South American timezones
  { value: 'ART', label: 'ART (Argentina Time) - UTC-3' },
  { value: 'BRT', label: 'BRT (Brasília Time) - UTC-3' },
  { value: 'CLT', label: 'CLT (Chile Standard Time) - UTC-4' },
  { value: 'CLST', label: 'CLST (Chile Summer Time) - UTC-3' },
  { value: 'COT', label: 'COT (Colombia Time) - UTC-5' },
  { value: 'ECT', label: 'ECT (Ecuador Time) - UTC-5' },
  { value: 'PET', label: 'PET (Peru Time) - UTC-5' },
  { value: 'GYT', label: 'GYT (Guyana Time) - UTC-4' },
  { value: 'PYT', label: 'PYT (Paraguay Time) - UTC-4' },
  { value: 'PYST', label: 'PYST (Paraguay Summer Time) - UTC-3' },
  { value: 'UYT', label: 'UYT (Uruguay Time) - UTC-3' },
  { value: 'VET', label: 'VET (Venezuela Time) - UTC-4' },
  { value: 'BOT', label: 'BOT (Bolivia Time) - UTC-4' },
  { value: 'FKT', label: 'FKT (Falkland Islands Time) - UTC-3' },

  // Canadian timezones
  { value: 'NST', label: 'NST (Newfoundland Standard Time) - UTC-3:30' },
  { value: 'NDT', label: 'NDT (Newfoundland Daylight Time) - UTC-2:30' },
  { value: 'AST', label: 'AST (Atlantic Standard Time) - UTC-4' },
  { value: 'ADT', label: 'ADT (Atlantic Daylight Time) - UTC-3' },
  { value: 'EST', label: 'EST (Eastern Standard Time) - UTC-5' },
  { value: 'EDT', label: 'EDT (Eastern Daylight Time) - UTC-4' },
  { value: 'CST', label: 'CST (Central Standard Time) - UTC-6' },
  { value: 'CDT', label: 'CDT (Central Daylight Time) - UTC-5' },
  { value: 'MST', label: 'MST (Mountain Standard Time) - UTC-7' },
  { value: 'MDT', label: 'MDT (Mountain Daylight Time) - UTC-6' },
  { value: 'PST', label: 'PST (Pacific Standard Time) - UTC-8' },
  { value: 'PDT', label: 'PDT (Pacific Daylight Time) - UTC-7' },

  // Mexican timezones
  { value: 'CST', label: 'CST (Central Standard Time) - UTC-6' },
  { value: 'CDT', label: 'CDT (Central Daylight Time) - UTC-5' },
  { value: 'MST', label: 'MST (Mountain Standard Time) - UTC-7' },
  { value: 'MDT', label: 'MDT (Mountain Daylight Time) - UTC-6' },
  { value: 'PST', label: 'PST (Pacific Standard Time) - UTC-8' },
  { value: 'PDT', label: 'PDT (Pacific Daylight Time) - UTC-7' },

  // Central American timezones
  { value: 'CST', label: 'CST (Central Standard Time) - UTC-6' },
  { value: 'CDT', label: 'CDT (Central Daylight Time) - UTC-5' },
  { value: 'EST', label: 'EST (Eastern Standard Time) - UTC-5' },
  { value: 'EDT', label: 'EDT (Eastern Daylight Time) - UTC-4' },

  // Pacific islands
  { value: 'MHT', label: 'MHT (Marshall Islands Time) - UTC+12' },
  { value: 'FJT', label: 'FJT (Fiji Time) - UTC+12' },
  { value: 'FJST', label: 'FJST (Fiji Summer Time) - UTC+13' },
  { value: 'GALT', label: 'GALT (Galápagos Time) - UTC-6' },
  { value: 'GAMT', label: 'GAMT (Gabon Mean Time) - UTC-1' },
  { value: 'GILT', label: 'GILT (Gilbert Islands Time) - UTC+12' },
  { value: 'KOST', label: 'KOST (Kosrae Time) - UTC+11' },
  { value: 'MAGT', label: 'MAGT (Magadan Time) - UTC+12' },
  { value: 'MART', label: 'MART (Marquesas Islands Time) - UTC-9:30' },
  { value: 'MAWT', label: 'MAWT (Mawson Station Time) - UTC+5' },
  { value: 'NUT', label: 'NUT (Niue Time) - UTC-11' },
  { value: 'PONT', label: 'PONT (Pohnpei Standard Time) - UTC+11' },
  { value: 'PST', label: 'PST (Pitcairn Standard Time) - UTC-8' },
  { value: 'SST', label: 'SST (Samoa Standard Time) - UTC-11' },
  { value: 'SBT', label: 'SBT (Solomon Islands Time) - UTC+11' },
  { value: 'TAHT', label: 'TAHT (Tahiti Time) - UTC-10' },
  { value: 'TKT', label: 'TKT (Tokelau Time) - UTC+13' },
  { value: 'TOT', label: 'TOT (Tonga Time) - UTC+13' },
  { value: 'VUT', label: 'VUT (Vanuatu Time) - UTC+11' },
  { value: 'WAKT', label: 'WAKT (Wake Island Time) - UTC+12' },
  { value: 'WFT', label: 'WFT (Wallis & Futuna Time) - UTC+12' },

  // Other specialized timezones
  { value: 'CHOST', label: 'CHOST (Choibalsan Standard Time) - UTC+8' },
  { value: 'HOVST', label: 'HOVST (Hovd Standard Time) - UTC+7' },
  { value: 'IRKT', label: 'IRKT (Irkutsk Time) - UTC+8' },
  { value: 'KRAT', label: 'KRAT (Krasnoyarsk Time) - UTC+7' },
  { value: 'NOVT', label: 'NOVT (Novosibirsk Time) - UTC+7' },
  { value: 'OMST', label: 'OMST (Omsk Standard Time) - UTC+6' },
  { value: 'YEKT', label: 'YEKT (Yekaterinburg Time) - UTC+5' },
  { value: 'YAKT', label: 'YAKT (Yakutsk Time) - UTC+9' },
  { value: 'VLAT', label: 'VLAT (Vladivostok Time) - UTC+10' },
  { value: 'SAKT', label: 'SAKT (Sakhalin Time) - UTC+11' },
  { value: 'ANAT', label: 'ANAT (Anadyr Time) - UTC+12' },
  { value: 'PETT', label: 'PETT (Kamchatka Time) - UTC+12' },
  { value: 'RET', label: 'RET (Réunion Time) - UTC+4' },
  { value: 'MUT', label: 'MUT (Mauritius Time) - UTC+4' },
  { value: 'SCT', label: 'SCT (Seychelles Time) - UTC+4' },
  { value: 'MVT', label: 'MVT (Maldives Time) - UTC+5' },
  { value: 'BTT', label: 'BTT (Bhutan Time) - UTC+6' },
  { value: 'IOT', label: 'IOT (Indian Ocean Territory Time) - UTC+6' },
  { value: 'CXT', label: 'CXT (Christmas Island Time) - UTC+7' },
  { value: 'DAVT', label: 'DAVT (Davis Time) - UTC+7' },
  { value: 'MHT', label: 'MHT (Marshall Islands Time) - UTC+12' },
  { value: 'NFT', label: 'NFT (Norfolk Time) - UTC+11' },
  { value: 'PHT', label: 'PHT (Philippines Time) - UTC+8' },
  { value: 'PWT', label: 'PWT (Palau Time) - UTC+9' },
  { value: 'QYZT', label: 'QYZT (Qyzylorda Time) - UTC+5' },
  { value: 'TFT', label: 'TFT (French Southern and Antarctic Time) - UTC+5' },
  { value: 'ULAT', label: 'ULAT (Ulaanbaatar Time) - UTC+8' },
  { value: 'UZT', label: 'UZT (Uzbekistan Time) - UTC+5' },
  { value: 'HST', label: 'HST (Hawaii Standard Time) - UTC-10' },
  { value: 'MST', label: 'MST (Mountain Standard Time) - UTC-7' }
];

// Language options
export const languages = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' },
  { value: 'it', label: 'Italian' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'ru', label: 'Russian' },
  { value: 'ja', label: 'Japanese' },
  { value: 'zh', label: 'Chinese (Mandarin)' },
  { value: 'zh-TW', label: 'Chinese (Traditional)' },
  { value: 'ko', label: 'Korean' },
  { value: 'ar', label: 'Arabic' },
  { value: 'hi', label: 'Hindi' },
  { value: 'bn', label: 'Bengali' },
  { value: 'ur', label: 'Urdu' },
  { value: 'pa', label: 'Punjabi' },
  { value: 'mr', label: 'Marathi' },
  { value: 'gu', label: 'Gujarati' },
  { value: 'ta', label: 'Tamil' },
  { value: 'te', label: 'Telugu' },
  { value: 'kn', label: 'Kannada' },
  { value: 'ml', label: 'Malayalam' },
  { value: 'si', label: 'Sinhala' },
  { value: 'th', label: 'Thai' },
  { value: 'vi', label: 'Vietnamese' },
  { value: 'id', label: 'Indonesian' },
  { value: 'ms', label: 'Malay' },
  { value: 'fil', label: 'Filipino' },
  { value: 'ne', label: 'Nepali' },
  { value: 'my', label: 'Burmese' },
  { value: 'km', label: 'Khmer' },
  { value: 'lo', label: 'Lao' },
  { value: 'ka', label: 'Georgian' },
  { value: 'hy', label: 'Armenian' },
  { value: 'az', label: 'Azerbaijani' },
  { value: 'kk', label: 'Kazakh' },
  { value: 'ky', label: 'Kyrgyz' },
  { value: 'uz', label: 'Uzbek' },
  { value: 'tg', label: 'Tajik' },
  { value: 'tk', label: 'Turkmen' },
  { value: 'mn', label: 'Mongolian' },
  { value: 'bo', label: 'Tibetan' },
  { value: 'dv', label: 'Divehi' },
  { value: 'ps', label: 'Pashto' },
  { value: 'sd', label: 'Sindhi' },
  { value: 'ckb', label: 'Sorani (Kurdish)' },
  { value: 'ku', label: 'Kurmanji (Kurdish)' },
  { value: 'tr', label: 'Turkish' },
  { value: 'el', label: 'Greek' },
  { value: 'he', label: 'Hebrew' },
  { value: 'fa', label: 'Persian (Farsi)' },
  { value: 'am', label: 'Amharic' },
  { value: 'so', label: 'Somali' },
  { value: 'sw', label: 'Swahili' },
  { value: 'zu', label: 'Zulu' },
  { value: 'af', label: 'Afrikaans' },
  { value: 'is', label: 'Icelandic' },
  { value: 'fo', label: 'Faroese' },
  { value: 'da', label: 'Danish' },
  { value: 'sv', label: 'Swedish' },
  { value: 'no', label: 'Norwegian' },
  { value: 'nb', label: 'Norwegian Bokmål' },
  { value: 'nn', label: 'Norwegian Nynorsk' },
  { value: 'fi', label: 'Finnish' },
  { value: 'et', label: 'Estonian' },
  { value: 'lv', label: 'Latvian' },
  { value: 'lt', label: 'Lithuanian' },
  { value: 'pl', label: 'Polish' },
  { value: 'cs', label: 'Czech' },
  { value: 'sk', label: 'Slovak' },
  { value: 'hu', label: 'Hungarian' },
  { value: 'ro', label: 'Romanian' },
  { value: 'bg', label: 'Bulgarian' },
  { value: 'hr', label: 'Croatian' },
  { value: 'sr', label: 'Serbian' },
  { value: 'sl', label: 'Slovenian' },
  { value: 'bs', label: 'Bosnian' },
  { value: 'mk', label: 'Macedonian' },
  { value: 'sq', label: 'Albanian' },
  { value: 'mt', label: 'Maltese' },
  { value: 'cy', label: 'Welsh' },
  { value: 'ga', label: 'Irish' },
  { value: 'gd', label: 'Scottish Gaelic' },
  { value: 'eu', label: 'Basque' },
  { value: 'ca', label: 'Catalan' },
  { value: 'gl', label: 'Galician' },
  { value: 'oc', label: 'Occitan' },
  { value: 'nl', label: 'Dutch' },
  { value: 'lb', label: 'Luxembourgish' },
  { value: 'uk', label: 'Ukrainian' },
  { value: 'be', label: 'Belarusian' },
  { value: 'yi', label: 'Yiddish' },
  { value: 'yi', label: 'Yiddish' },
  { value: 'jv', label: 'Javanese' },
  { value: 'su', label: 'Sundanese' },
  { value: 'mad', label: 'Madurese' },
  { value: 'min', label: 'Minangkabau' },
  { value: 'ace', label: 'Acehnese' },
  { value: 'bjn', label: 'Banjar' },
  { value: 'bug', label: 'Buginese' },
  { value: 'tet', label: 'Tetum' },
  { value: 'pau', label: 'Palauan' },
  { value: 'chm', label: 'Mari' },
  { value: 'krl', label: 'Karelian' },
  { value: 'vep', label: 'Veps' },
  { value: 'sjo', label: 'Xibe' },
  { value: 'ab', label: 'Abkhaz' },
  { value: 'os', label: 'Ossetian' },
  { value: 'lez', label: 'Lezgi' },
  { value: 'ava', label: 'Avar' },
  { value: 'dar', label: 'Dargwa' },
  { value: 'inh', label: 'Ingush' },
  { value: 'che', label: 'Chechen' },
  { value: 'kum', label: 'Kumyk' },
  { value: 'lbe', label: 'Lak' },
  { value: 'tab', label: 'Tabasaran' },
  { value: 'ady', label: 'Adyghe' },
  { value: 'kbd', label: 'Kabardian' },
  { value: 'xmf', label: 'Mingrelian' },
  { value: 'lzz', label: 'Laz' },
  { value: 'gmy', label: 'Mingrelian' },
  { value: 'chr', label: 'Cherokee' },
  { value: 'mus', label: 'Creek' },
  { value: 'cho', label: 'Choctaw' },
  { value: 'lui', label: 'Luiseno' },
  { value: 'yua', label: 'Yucatec Maya' },
  { value: 'nah', label: 'Nahuatl' },
  { value: 'oto', label: 'Otomanguean' },
  { value: 'zap', label: 'Zapotec' },
  { value: 'mix', label: 'Mixtec' },
  { value: 'maz', label: 'Mazahua' },
  { value: 'tzh', label: 'Tzeltal' },
  { value: 'tzj', label: 'Tzotzil' },
  { value: 'cni', label: 'Asháninka' },
  { value: 'gn', label: 'Guarani' },
  { value: 'ay', label: 'Aymara' },
  { value: 'qu', label: 'Quechua' },
  { value: 'arn', label: 'Mapudungun' },
  { value: 'aoc', label: 'Pemon' },
  { value: 'guc', label: 'Wayuu' },
  { value: 'wap', label: 'Wapishana' },
  { value: 'cab', label: 'Garifuna' },
  { value: 'misk', label: 'Miskito' },
  { value: 'bzf', label: 'Bozaba' },
  { value: 'br', label: 'Breton' },
  { value: 'co', label: 'Corsican' },
  { value: 'frp', label: 'Franco-Provençal' },
  { value: 'fur', label: 'Friulian' },
  { value: 'lld', label: 'Ladin' },
  { value: 'lij', label: 'Ligurian' },
  { value: 'lmo', label: 'Lombard' },
  { value: 'pms', label: 'Piedmontese' },
  { value: 'srd', label: 'Sardinian' },
  { value: 'sc', label: 'Sicilian' },
  { value: 'vec', label: 'Venetian' },
  { value: 'emx', label: 'Erzya' },
  { value: 'myv', label: 'Moksha' },
  { value: 'mdf', label: 'Moksha' },
  { value: 'chm', label: 'Mari' },
  { value: 'mrj', label: 'Hill Mari' },
  { value: 'kpv', label: 'Komi-Zyrian' },
  { value: 'koi', label: 'Komi-Permyak' },
  { value: 'udm', label: 'Udmurt' },
  { value: 'kv', label: 'Komi' },
  { value: 'tt', label: 'Tatar' },
  { value: 'ba', label: 'Bashkir' },
  { value: 'cv', label: 'Chuvash' },
  { value: 'xal', label: 'Kalmyk' },
  { value: 'sah', label: 'Yakut' },
  { value: 'tyv', label: 'Tuvan' },
  { value: 'bkx', label: 'Baik' },
  { value: 'bxr', label: 'Russia Buriat' },
  { value: 'bxu', label: 'Mongolia Buriat' },
  { value: 'bxg', label: 'China Buriat' },
  { value: 'ha', label: 'Hausa' },
  { value: 'yo', label: 'Yoruba' },
  { value: 'ig', label: 'Igbo' },
  { value: 'ee', label: 'Ewe' },
  { value: 'tw', label: 'Twi' },
  { value: 'ak', label: 'Akan' },
  { value: 'kr', label: 'Kanuri' },
  { value: 'ff', label: 'Fula' },
  { value: 'wo', label: 'Wolof' },
  { value: 'bm', label: 'Bambara' },
  { value: 'kq', label: 'Korana' },
  { value: 'naq', label: 'Nama' },
  { value: 'tsj', label: 'Tsonga' },
  { value: 'xh', label: 'Xhosa' },
  { value: 'zu', label: 'Zulu' },
  { value: 'nso', label: 'Northern Sotho' },
  { value: 'st', label: 'Southern Sotho' },
  { value: 'tn', label: 'Tswana' },
  { value: 'ss', label: 'Swazi' },
  { value: 've', label: 'Venda' },
  { value: 'nr', label: 'Ndebele' },
  { value: 'om', label: 'Oromo' },
  { value: 'ti', label: 'Tigrinya' },
  { value: 'tig', label: 'Tigre' },
  { value: 'har', label: 'Harari' },
  { value: 'gax', label: 'Oromo' },
  { value: 'sid', label: 'Sidamo' },
  { value: 'wal', label: 'Wolaytta' },
  { value: 'dar', label: 'Dargwa' },
  { value: 'kab', label: 'Kabyle' },
  { value: 'shy', label: 'Tachawit' },
  { value: 'tmh', label: 'Tamashek' },
  { value: 'zen', label: 'Zenaga' },
  { value: 'kab', label: 'Kabyle' },
  { value: 'arq', label: 'Algerian Arabic' },
  { value: 'aeb', label: 'Tunisian Arabic' },
  { value: 'apc', label: 'North Levantine Arabic' },
  { value: 'acw', label: 'Hijazi Arabic' },
  { value: 'ayl', label: 'Libyan Arabic' },
  { value: 'avl', label: 'Eastern Egyptian Bedawi Arabic' },
  { value: 'ars', label: 'Najdi Arabic' },
  { value: 'ary', label: 'Moroccan Arabic' },
  { value: 'arz', label: 'Egyptian Arabic' },
  { value: 'afb', label: 'Gulf Arabic' },
  { value: 'pdc', label: 'Pennsylvania German' },
  { value: 'sli', label: 'Lower Silesian' },
  { value: 'wae', label: 'Walser' },
  { value: 'gsw', label: 'Swiss German' },
  { value: 'bar', label: 'Bavarian' },
  { value: 'cim', label: 'Cimbrian' },
  { value: 'moe', label: 'Mòcheno' },
  { value: 'hrx', label: 'Hunsrik' },
  { value: 'syc', label: 'Syriac' },
  { value: 'tmr', label: 'Jewish Babylonian Aramaic' },
  { value: 'jpa', label: 'Jewish Palestinian Aramaic' },
  { value: 'sam', label: 'Samaritan Aramaic' },
  { value: 'arc', label: 'Official Aramaic' },
  { value: 'aii', label: 'Assyrian Neo-Aramaic' },
  { value: 'amc', label: 'Amharic' },
  { value: 'geez', label: 'Ge\'ez' },
  { value: 'tir', label: 'Tigrinya' },
  { value: 'har', label: 'Harari' },
  { value: 'xmt', label: 'Matbat' },
  { value: 'sux', label: 'Sumerian' },
  { value: 'akk', label: 'Akkadian' },
  { value: 'hbo', label: 'Ancient Hebrew' },
  { value: 'phn', label: 'Phoenician' },
  { value: 'uga', label: 'Ugaritic' },
  { value: 'sem', label: 'Semitic' },
  { value: 'egy', label: 'Ancient Egyptian' },
  { value: 'cop', label: 'Coptic' },
  { value: 'ber', label: 'Berber' },
  { value: 'kab', label: 'Kabyle' },
  { value: 'shy', label: 'Tachawit' },
  { value: 'tmh', label: 'Tamashek' },
  { value: 'zen', label: 'Zenaga' },
  { value: 'rif', label: 'Tarifit' },
  { value: 'tzm', label: 'Central Atlas Tamazight' },
  { value: 'taq', label: 'Tamasheq' },
  { value: 'thv', label: 'Tahaggart Tamahaq' },
  { value: 'ttq', label: 'Tawallammat Tamajaq' },
  { value: 'thx', label: 'Tayart Tamajeq' },
  { value: 'aoz', label: 'Atoor' },
  { value: 'kab', label: 'Kabyle' },
  { value: 'shy', label: 'Tachawit' },
  { value: 'tmh', label: 'Tamashek' },
  { value: 'zen', label: 'Zenaga' },
  { value: 'rif', label: 'Tarifit' },
  { value: 'tzm', label: 'Central Atlas Tamazight' },
  { value: 'taq', label: 'Tamasheq' },
  { value: 'thv', label: 'Tahaggart Tamahaq' },
  { value: 'ttq', label: 'Tawallammat Tamajaq' },
  { value: 'thx', label: 'Tayart Tamajeq' },
  { value: 'aoz', label: 'Atoor' }
];

// Get cities by country code
export const getCitiesByCountry = (countryCode) => {
  return cities[countryCode] || defaultCities;
};
